<template>
  <main id="mining_body" v-show="startRender">
    <top-menu :top_title="top_title"></top-menu>
    <div class="div_padding"></div>
    <div class="wrapper">
      <div class="main_text_box">
        <h3>있는 놈이 <span id="thehae">더해</span></h3>
        <h3>FUS를 더하는 다양한 방법</h3>
        <div class="" style="height: 10px"></div>
        <p>
          채굴권을 획득하여 채굴에 참여해보세요.<br />
          채굴권은 다양한 앱내 활동으로 획득하실 수 있어요.
        </p>
      </div>
      <div class="num_data_div">
        <div class="row1" v-for="(mining, idx) in miningList" :key="idx">
          <div class="num_data">
            <p>+{{ mining.ticketCnt }}</p>
            <span>{{ mining.ticketNm }}</span>
            <div>{{ mining.tickeText }}</div>
          </div>
        </div>
      </div>
      <div class="mining_games">
        <div class="mining_banner_div" onclick="location.href='/roulette'">
          <img src="images/basic/img/roullette_img.png" alt="" />
          <div class="copy">
            <h3>
              <span>돌리기만 해도 채굴!</span><br />
              대박찬스까지 더해보세요.
            </h3>
            <div class="btn">룰렛 돌리기</div>
          </div>
        </div>
        <div class="mining_banner_div2" onclick="location.href='/slotmachine'">
          <img src="images/basic/img/slot_img.png" alt="" />
          <div class="copy">
            <h3>
              한방에 역전 가능!<br />
              슬롯머신도 돌려요.
            </h3>
            <div class="btn">슬롯머신 돌리기</div>
          </div>
        </div>
        <div class="mining_banner_div3">
          <div class="banner_div" onclick="location.href='/luckycard'">
            <img src="images/basic/img/banner-mining-luckycard.png" alt="" />
            <div class="copy">
              <span>온 우주의 기운을 모아</span>
              <p>복권긁기</p>
            </div>
          </div>
          <div class="banner_div" onclick="location.href='/dice'">
            <img src="images/basic/img/banner-mining-dice.png" alt="" />
            <div class="copy">
              <span>순전히 운에 맡긴다</span>
              <p>주사위 굴리기</p>
            </div>
          </div>
        </div>
      </div>
      <div class="app_extanal">
        <img src="images/basic/img/external_img.png" alt="" />
      </div>
      <div class="rank_wrapper updown" id="bet" style="visibility: hidden; display: none">
        <div class="sub_text_box">
          <h3>
            <img src="images/basic/img/game-plusminus-title.svg" alt="" />
            {{ round }}회차
            <a href="#" class="help">
              <div class="baloon">
                <p>게임 참가비 10FUS가 있으며, 오늘 기준 이틀 뒤의 해당 코인의 등락을 예상하고 모두 맞추신 분께 FUS가 지급됩니다.</p>
                <p>해당 코인에 투자하는것이 아니며, 해당 코인의 등락만을 기준으로 승패가 정해지는 게임입니다.</p>
                <p>참여자가 많을수록 지급되는 FUS가 늘어나며, 당첨자가 중복일 경우 전체 상금에서 당첨자 수만큼 나누어 지급됩니다.</p>
                <p>KST 00:00:00 ~ 23:59:59를 기준으로 합니다.</p>
              </div>
            </a>
            <div class="more">
              <a href="/mining_detail" class="more"><img src="images/basic/icon/more2.svg" alt="" /></a>
            </div>
          </h3>
          <p v-html="noti"></p>
        </div>

        <div class="coin_rank_div">
          <div class="coin_rank_ul">
            <div class="coin_rank_list" v-for="(type, index) in type" :key="index">
              <div class="coin_rank_left">
                <div class="coin_logo" v-bind:style="{ backgroundImage: 'url(' + type.logo + ')' }"></div>
                <div class="">
                  <p>{{ type.name }}</p>
                  <span v-if="type.change == 'zero'" class="zero">오늘 {{ type.point }}%</span>
                  <span v-if="type.change == 'plus'" class="plus">오늘 {{ type.point }}%</span>
                  <span v-if="type.change == 'minus'" class="minus">오늘 {{ type.point }}%</span>
                </div>
              </div>
              <div class="coin_rank_right">
                <div class="plus">
                  <p></p>
                  <span>{{ type.plus }}명</span>
                </div>
                <div class="minus">
                  <p></p>
                  <span>{{ type.minus }}명</span>
                </div>
              </div>
            </div>
          </div>
          <div class="apply btn">
            <a href="#">코인 등락 + -를 선택하세요.</a>
          </div>
        </div>
      </div>
    </div>
    <div class="mining_bottom">
      <div class="mining_level">
        <div class="line">
          <div class="marker" :style="`width:${bottomInfo.percent}%`"></div>
        </div>
      </div>
      <div class="level_detail" id="mining_level">
        <div class="level_div">
          <div>
            <div class="fus_help" style="position: relative">
              <!--  -->
              <p>보유 채굴권</p>
              <span class="level"><img src="images/basic/icon/mine-today.svg" /> {{ bottomInfo.ticketCntView }}</span>
              <!-- <div href="" class="help_bottom" @click="toggleTicketHelp($event)">
                <div class="baloon">
                  <p>보유 채굴권</p>
                </div>
              </div> -->
            </div>
          </div>
          <div>
            <div class="fus_help" style="position: relative">
              <!--  -->
              <p>1일 획득 채굴권</p>
              <span class="level"><img src="images/basic/icon/mine-ticket-today.svg" /> {{ bottomInfo.todayTicketCntView }}</span>
              <!-- <div href="" class="help_bottom" @click="toggleTodayTicket($event)">
                <div class="baloon">
                  <p>획득 채굴권</p>
                </div>
              </div> -->
            </div>
          </div>
          <div class="right">
            <span class="level">{{ bottomInfo.accountCoinView }}</span>
            <span>FUS </span>
            <!--
            <a href="#" class="help">
              <div class="baloon">
                <p>게임 참가비 10FUS가 있으며, 오늘 기준 이틀 뒤의 해당 코인의 등락을 예상하고 모두 맞추신 분께 FUS가 지급됩니다.</p>
                <p>해당 코인에 투자하는것이 아니며, 해당 코인의 등락만을 기준으로 승패가 정해지는 게임입니다.</p>
                <p>참여자가 많을수록 지급되는 FUS가 늘어나며, 당첨자가 중복일 경우 전체 상금에서 당첨자 수만큼 나누어 지급됩니다.</p>
                <p>KST 00:00:00 ~ 23:59:59를 기준으로 합니다.</p>
              </div>
            </a>
            -->
          </div>
        </div>
      </div>
    </div>
    <bottom-menu></bottom-menu>
  </main>
</template>

<script>
import TopMenu from "@/components/common/TopMenu";
import BottomMenu from "@/components/common/BottomMenu";
import { fetchMiningInfo } from "@/api/info";
import { main } from "@/api/mining";
import EventBus from "@/EventBus";
export default {
  components: {
    TopMenu,
    BottomMenu,
  },
  created() {
    window.VueRoot = this;
    EventBus.$emit("top_title", '<span id="top_title">채굴</span>');
    //this.startRender = true;
    fetchMiningInfo().then(({ data }) => {
      this.miningList = data.resultList;
    });
    main().then((data) => {
      this.startRender = true;
      setTimeout(function () {
        window.VueRoot.bottomInfo = data.data;
        console.log(data.data);
      }, 200);
    });
  },
  mounted() {
    document.getElementById("icon_mining").src = "images/basic/menu_icon/tabbar-mining-on.svg";
    window.$(".marker").css("width", "50%");
    window.$(".coin_rank_ul .coin_rank_right > div").click(function () {
      window.$(this).toggleClass("selected").siblings().removeClass("selected");
    });
    window.$(".coin_rank_ul .coin_rank_list:last-child .coin_rank_right > div").click(function () {
      window.$(".apply.btn").addClass("submit");
      window.$(".apply.btn a").text("선택한 결과로 참여");
    });

    window.$(document).ready(function () {
      window.$('a[href="#"]').click(function (e) {
        e.preventDefault();
      });
    });

    window.$(".help_bottom").click(function (e) {
      window.$(this).children(".baloon").slideToggle(200);
      window.$(this).toggleClass("active");
      e.preventDefault();
    });
  },
  data() {
    return {
      round: "13",
      noti: "이틀 뒤의 코인의 등락을 예상하고 모두 맞추신 분께 FUS가 지급됩니다. KST 00:00:00 ~ 23:59:59를 기준으로 합니다.",
      type: [
        { name: "Bitcoin", point: "+0.78", logo: "/images/basic/img/coin1@3x.png", plus: 9780, minus: 10980, change: "zero" },
        { name: "Etherium", point: "+0.78", logo: "/images/basic/img/coin2@3x.png", plus: 1780, minus: 4230, change: "minus" },
        { name: "Bitcoin", point: "-0.78", logo: "/images/basic/img/coin3@3x.png", plus: 9780, minus: 10980, change: "plus" },
        { name: "Bitcoin", point: "-0.78", logo: "/images/basic/img/coin4@3x.png", plus: 9780, minus: 10980, change: "minus" },
        { name: "Bitcoin", point: "+0.78", logo: "/images/basic/img/coin5@3x.png", plus: 9780, minus: 10980, change: "plus" },
      ],
      fus: "2400.05",
      top_title: '<span id="top_title">채굴</span>',
      isBottomActive: false,
      isMiddleActive: false,
      miningList: [],
      bottomInfo: {},
      startRender: false,
    };
  },
  methods: {
    toggleTicketHelp(e) {
      window.$(e.target).children(".main_baloon").slideToggle("fast");
      window.$(e.target).toggleClass("active");
    },
  },
};
</script>

<style scoped>
.help_bottom {
  background: url(/images/basic/icon/help.svg) no-repeat center;
  background-size: 100% 100%;
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: text-top;
}
.help_bottom.active {
  background-image: url(/images/basic/icon/help-close.svg);
}
.help_bottom img {
  display: none;
}
.help_bottom .baloon {
  background-color: var(--Gray-Dark);
  border-radius: 5px;
  position: absolute;
  left: 0;
  top: 26px;
  width: 100px;
  padding: 15px;
  display: none;
  line-height: initial;
  text-align: left;
}
.help_bottom .baloon {
  top: initial;
  bottom: 50px;
  left: 7vw;
}

.help_bottom .baloon p {
  color: var(--Gray-Pale) !important;
  font-weight: normal !important;
  font-size: 12px !important;
  margin-bottom: 5px;
  text-align: center;
}
</style>
